import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { InitiateLifestyleRewardsRequest } from 'src/app/interfaces/lifestyle-rewards/InitiateLifestyleRewardsRequest';

@Injectable()
export class LifestyleRewardsApi extends HttpClient {
  private baseUrl = environment.production 
    ? '/channel-virtual/api/v1/lifestyle-rewards' 
    : environment.baseUrl + '/lifestyle-rewards';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initiateLifestyleRewards(sessionToken: string, request: InitiateLifestyleRewardsRequest): Observable<any> {
    const url = this.baseUrl + '/initiate?sessionToken=' + sessionToken;
    return super.post(url, request);
  }
}
